import controller from './nav-bar.controller';

export default {
  controller,
  template: require('./nav-bar.html')
};



// WEBPACK FOOTER //
// src/app/components/nav-bar/nav-bar.component.ts